import { DriverLicenseCategoryData } from "@/common/types/driverLicenseCategory";
import { EquipmentTierData } from "@/common/types/equipmentTier";
import { MetaResponse } from "@/common/types/metaResponse";

export enum RequiredFieldName {
  InfocarFields = "infocar_fields",
  LicensePlate = "license_plate",
  ChassisNumber = "chassis_number",
  Renavam = "renavam",
  SerialNumber = "serial_number",
  OfficialName = "official_name",
  TankCapacity = "tank_capacity",
}

export type UnitForConsumption = "kilometers" | "hours";

export type EquipmentCategoryData = {
  id: string;
  description: string;
  display_name: string;
  field_for_display: string;
  max_tank_capacity?: string;
  equipment_tier: EquipmentTierData | null;
  required_field_names?: RequiredFieldName[];
  supports_infocar_data_enrichment: boolean;
  unit_for_consumption: UnitForConsumption;
  equipments_count: number;
  driver_license_category_equipment_categories: {
    id: string;
    driver_license_category: DriverLicenseCategoryData
  }[]
  bypass_consumption_usage_validations: boolean;
};

export type EquipmentCategoriesResponse = {
  data: {
    data: EquipmentCategoryData[];
    meta: MetaResponse;
  };
};

export type EquipmentCategoryResponse = {
  data: {
    data: EquipmentCategoryData;
  };
};

export type EquipmentCategoryTableItem = Omit<
  EquipmentCategoryData,
  "display_name" | "description"
> & {
  display_name: JSX.Element;
  actions: JSX.Element;
};
